<div class="modal-header bg-light">
    <h4 class="modal-title">{{this.titulo}}</h4>
    <button *ngIf="this.paymentType === TipoPago.Indeterminado" type="button" class="btn-close" aria-label="Close" (click)="activeModal.close(false)"></button>
</div>

<div class="spinner-container" *ngIf="showProccess">
<ngx-spinner name="spinnerImporteFactura" bdOpacity=0.3bd
    Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
    <p style="color: white">{{processMessage}}</p>
</ngx-spinner>
</div>

<div *ngIf="!showProccess" class="modal-body" [formGroup]="pagosForm">

    <ng-container *ngIf="this.paymentType === TipoPago.Indeterminado">

        <!--TARJETA-->
        <div class="row">
            <div class="mb-3 row col-md-12">
                <label for="tarjetaFormControl" class="col-md-5 col-form-label">*Tarjeta</label>
                <div class="col-md-7">
                    <select id="tarjetaFormControl" class="form-select"
                        ngbTooltip="Seleccione el producto." formControlName="tarjetaFormControl">
                        <option *ngFor="let tarjeta of tarjetas" [ngValue]="tarjeta">
                        ({{ tarjeta.codigo }}) - {{ tarjeta.nombre }}
                        </option>
                    </select>
                    <loading-text-spinner *ngIf="cargandoTarjetas" message="Obteniendo tarjetas..."
                        color="primary">
                    </loading-text-spinner>
                </div>
            </div>
        </div>

        <!--NUMERO TARJETA-->
        <div class="row">
            <div class="mb-3 row col-md-12">
                <label for="numeroTarjetaFormControl" class="col-sm-5 col-form-label">*Número de tarjeta</label>
                <div class="col-sm-7">
                    <input class="form-control" appOnlyNumber formControlName="numeroTarjetaFormControl" placeholder="Últimos 4 dígitos" maxlength="4">
                    <div *ngIf="numeroTarjetaFormControl.invalid && numeroTarjetaFormControl.errors.required && (numeroTarjetaFormControl.dirty || numeroTarjetaFormControl.touched)" 
                        class="alert alert-danger">Requerido
                    </div>        
                </div>
            </div>
        </div>

        <!--LOTE CUPON-->
        <div class="row">
            <div class="mb-3 row col-md-12">
                <label for="loteCuponFormControl" class="col-sm-5 col-form-label">*Lote cupón</label>
                <div class="col-sm-7">
                    <input class="form-control" appOnlyNumber formControlName="loteCuponFormControl" placeholder="3 dígitos" maxlength="3">
                    <div *ngIf="loteCuponFormControl.invalid && loteCuponFormControl.errors.required && (loteCuponFormControl.dirty || loteCuponFormControl.touched)" 
                        class="alert alert-danger">Requerido
                    </div>
                </div>
            </div>
        </div>

        <!--NUMERO CUPON-->
        <div class="row">
            <div class="mb-3 row col-md-12">
                <label for="numeroCuponFormControl" class="col-sm-5 col-form-label">*Numero cupón:</label>
                <div class="col-sm-7">
                    <input class="form-control" appOnlyNumber formControlName="numeroCuponFormControl" placeholder="5 dígitos" maxlength="5">
                    <div *ngIf="numeroCuponFormControl.invalid && numeroCuponFormControl.errors.required && (numeroCuponFormControl.dirty || numeroCuponFormControl.touched)" 
                        class="alert alert-danger">Requerido
                    </div>
                </div>
            </div>
        </div>

    </ng-container>

    <!--POINT SMART-->
    <div class="row" *ngIf="this.paymentType === TipoPago.Point">
        <div class="mb-3 row col-md-12">
            <label for="pointFormControl" class="col-sm-5 col-form-label">*Point</label>
            <div class="col-sm-7">
                <select class="form-select" formControlName="pointFormControl" id="pointFormControl"
                    title="Seleccione el Point Smart">
                    <option value="" selected disabled>Seleccione un point de pago</option>
                    <option *ngFor="let p of points" [ngValue]="p">
                        {{ p.alias }}
                    </option>
                </select>
                <loading-text-spinner *ngIf="cargandoPoints" message="Obteniendo points..."
                    color="primary">
                </loading-text-spinner>
                <div *ngIf="pointFormControl.invalid && pointFormControl.errors.required && (pointFormControl.dirty || pointFormControl.touched)"
                    class="alert alert-danger">Requerido
                </div>
            </div>
        </div>
    </div>

    <!--IMPORTE-->
    <div class="row">
        <div class="mb-3 row col-md-12">
            <label for="importeFormControl" class="col-sm-5 col-form-label">*Importe</label>
            <div class="col-sm-7">
                <input class="form-control" appOnlyDecimal formControlName="importeFormControl" maxlength="50">
                <div *ngIf="importeFormControl.invalid && importeFormControl.errors.required && (importeFormControl.dirty || importeFormControl.touched)"
                    class="alert alert-danger">Requerido
                </div>
                <div *ngIf="importeFormControl.invalid && !controlarImporte() && (importeFormControl.dirty || importeFormControl.touched)"
                    class="alert alert-danger">El importe ingresado supera el monto a factura: ${{this.importe | number: '0.2-2' }}
                </div>
            </div>
        </div>
    </div>

    <ng-container *ngIf="this.paymentType === TipoPago.Indeterminado">

        <!--ARCHIVO-->
        <div class="row"> 
            <div class="mb-3 row col-md-12">
                <label for="importeFormControl" class="col-sm-5 form-label">*Adjuntar archivo imagen</label>
                <div class="col-sm-7">
                    <input accept="image/*" class="form-control" id="importeFormControl" type="file" (change)="onSelectedFile($event)">
                    <label class="custom-file-label mt-1" for="importeFormControl">{{ fileName }}</label>
                </div>
            </div>
        </div>

    </ng-container>  

    <loading-text-spinner *ngIf="cargandoAeroplanta" message="Obteniendo aeroplanta..."
        color="primary">
    </loading-text-spinner>

    <div class="alert alert-danger" *ngIf="error != null">
        {{error}}
    </div>

    <small class="text-danger">*Campos obligatorios.</small>
</div>
<div class="modal-footer justify-content-center">  
    <button *ngIf="currentState != PaymentState.IntencionPagoConfirmado" (click)="onClick()" class="btn btn-primary me-2" [disabled]="showProccess || pagosForm.invalid">
        <span *ngIf="!showProccess">Cargar {{this.paymentType === TipoPago.Indeterminado ? 'Cupón' : 'Venta'}}</span>
        <div *ngIf="showProccess" class="d-flex align-items-center">
        <div class="spinner-border text-light spinner-border-sm" role="status"></div>
        <span>Cargando {{this.paymentType === TipoPago.Indeterminado ? 'Cupón' : 'Venta'}}...</span>
        </div>
    </button>
    <button [disabled]="blockExit" type="button" class="btn btn-secondary" (click)="onClose()">
        Cancelar
    </button>
</div>